import React, { useState } from "react";
import { register } from "../../services/authServices";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar.js";
import Header from "../../components/Header.js";
import { useAuth } from "../../context/AuthContext.js";
import { useToast } from "../../context/ToastContext";

const Register = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const toast = useToast();

  const [form, setForm] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    role: 3,
    email: "",
    contactNumber: "",
    employeeId: "",
  });

  const [step, setStep] = useState(1);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = { ...form, role: Number(form.role) };
      const res = await register(formData);
      if (res && res.status === false) {
        throw new Error(res.message || "Registration failed.");
      }
      // alert("Registration successful!");
      toast.success("Registration successful");
      navigate("/validators");
    } catch (err) {
      // alert(err.message || "Registration failed");
      toast.error("Registration failed");
    }
  };

  const today = new Date().toLocaleDateString("en-GB", {
    weekday: "long",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <div className="py-8 px-[5rem] bg-[#fbfbfb] w-screen mx-auto">
      <Header title={"Settings"} date={today} />
      <h2 className="text-2xl font-semibold mb-2 text-[#585858]">
        Add Validator
      </h2>
      <span className="text-md font-semibold mb-4 text-gray-500">
        Total: {2}
      </span>
      <div className="flex flex-row justify-between mt-8 pt-8 pb-10 px-8 rounded-2xl outline outline-1 outline-gray-200 text-[#585858] bg-white">
        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-8 w-full">
          {/* Left Section */}
          <div>
            {["firstName", "middleName", "lastName", "email"].map((field) => (
              <label
                key={field}
                htmlFor={field}
                className="block w-full mb-4 capitalize"
              >
                {field.replace(/([A-Z])/g, " $1")}
                <input
                  id={field}
                  name={field}
                  type={field === "email" ? "email" : "text"}
                  placeholder={`Enter ${field.replace(/([A-Z])/g, " $1")}`}
                  value={form[field]}
                  onChange={handleChange}
                  required
                  className="w-full border-2 border-gray-200 px-5 py-3 rounded-lg mt-2"
                />
              </label>
            ))}
          </div>

          {/* Right Section */}
          <div>
            {["contactNumber", "employeeId"].map((field) => (
              <label
                key={field}
                htmlFor={field}
                className="block w-full mb-4 capitalize"
              >
                {field.replace(/([A-Z])/g, " $1")}
                <input
                  id={field}
                  name={field}
                  type={field === "contactNumber" ? "tel" : "employeeId"}
                  placeholder={`Enter ${field.replace(/([A-Z])/g, " $1")}`}
                  value={form[field]}
                  onChange={handleChange}
                  required
                  className="w-full border-2 border-gray-200 px-5 py-3 rounded-lg mt-2"
                  maxLength={field === "contactNumber" ? 10 : undefined}
                  pattern={field === "contactNumber" ? "[0-9]{10}" : undefined}
                />
              </label>
            ))}

            <label htmlFor="role" className="block w-full mb-4">
              Role
              <select
                id="role"
                name="role"
                value={form.role}
                onChange={handleChange}
                required
                className={`w-full border-2  border-gray-200 px-5 py-3 rounded-lg mt-2 ${
                  user.userRole.id !== 1 ? "bg-gray-200" : ""
                }`}
                disabled={user.userRole.id !== 1}
              >
                <option value="0">Select Role</option>
                <option value="2">Manager</option>
                <option value="3" selected>
                  Validator
                </option>
              </select>
            </label>

            <div className="text-right mt-10">
              <button
                type="submit"
                className="bg-[#6f81f5] text-white px-7 py-3 text-md rounded-lg hover:bg-[#5a6be0] transition cursor-pointer"
              >
                Register →
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
